import { useState } from "react";
import styles from "./SaveJsonButton.module.css";

const FEEDBACK_DELAY_MS = 700;

export default function SaveJsonButton({ level }) {
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);

  if (isSuccess) {
    return (
      <p className={styles.successCopiedText}>JSON copied to Clipboard!</p>
    );
  }
  if (isError) {
    return (
      <p className={styles.failedCopiedText}>Clipboard action not supported.</p>
    );
  }
  return (
    <button
      className="secondary-ui-button"
      onClick={() => {
        const outputJson = level.editor.getJSON();
        const outputString = JSON.stringify(outputJson, null, 2);
        window.navigator.clipboard.writeText(outputString).then(
          function () {
            // Show Green pixel-text
            setIsSuccess(true);

            // Clear it out after a delay
            setTimeout(() => {
              setIsSuccess(false);
            }, FEEDBACK_DELAY_MS);
          },
          function () {
            console.error("Error copying pixel-text");

            // Show Red error pixel-text
            setIsError(true);

            // Clear it out after a delay
            setTimeout(() => {
              setIsError(false);
            }, FEEDBACK_DELAY_MS);
          }
        );
      }}
    >
      Get JSON
    </button>
  );
}
